import React from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import Link from 'Components/Link';

const cx = classNames.bind(styles);

// these elements must be focusable, e.g. with `tabIndex={-1}`
const items = [
  { name: 'zur Hauptnavigation', hash: 'header-bar' },
  { name: 'zum Hauptinhalt', hash: 'main-content' },
  { name: 'zu den Kontaktinformationen', hash: 'footer' },
  { name: 'zu den rechtlichen Angaben', hash: 'footer-legal' },
];

// In case any headline element can be found inside the scroll-element,
// it will be focused to trigger a screen reader announcement.
const screenReaderTrigger = (id) => {
  const scrollTarget = document.getElementById(id);
  if (scrollTarget) {
    const headlineElements = scrollTarget.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, [role=heading]'
    );
    if (headlineElements.length > 0) {
      const he = headlineElements[0];

      if (!he.hasAttribute('tabindex')) {
        he.setAttribute('tabindex', '-1');
      }
      he.style.outline = 'none';
      he.focus();
    }
  }
};

const BypassBlock = () => (
  <ol className={cx('bypassblock')}>
    {items.map((item, itemIndex) => (
      <li key={itemIndex}>
        <Link
          to={`#${item.hash}`}
          label={item.name}
          onClick={() => screenReaderTrigger(item.hash)}
        />
      </li>
    ))}
  </ol>
);

export default BypassBlock;
